import { SchedulingStatus } from '../api/scheduling';

export const formatSchedulingStatus = scheduling_status => {
   switch(scheduling_status){
      case SchedulingStatus.scheduled:
         return  'Agendado';
         case SchedulingStatus.rescheduled:
         return  'Reagendado';
      case SchedulingStatus.inLine:
         return 'Na Fila';
      case SchedulingStatus.called:
         return 'Chamado';
      case SchedulingStatus.transit:
         return 'Em Trânsito';
      case SchedulingStatus.inProgress:
         return 'Atendimento';
      case SchedulingStatus.delayed:
         return 'Atrasado';
      case SchedulingStatus.canceled:
         return 'Cancelado';
      case SchedulingStatus.completed:
         return 'Concluido';
      case SchedulingStatus.all:
         return 'Todos';

      default:
         return "";
   }
}
